var AppHeader = function AppHeader() {
  return import('@/components/organisms/AppHeader');
};
var AppFooter = function AppFooter() {
  return import('@/components/organisms/AppFooter');
};
import Head from '~/assets/scripts/Head';
var ExternalSiteModal = function ExternalSiteModal() {
  return import('@/components/organisms/ExternalSiteModal');
};
export default {
  components: {
    AppHeader: AppHeader,
    AppFooter: AppFooter,
    Head: Head,
    ExternalSiteModal: ExternalSiteModal
  },
  computed: {
    externalSite: function externalSite() {
      return useAuthStore().getExternalSite;
    },
    isExternalSiteModalShown: function isExternalSiteModalShown() {
      return useAuthStore().getIsExternalSiteModalShown;
    }
  },
  methods: {
    setExternalSite: function setExternalSite(obj) {
      useAuthStore().setExternalSite(obj);
    }
  },
  head: function head() {
    var head = new Head({
      title: this.$t('common.meta.title'),
      description: this.$t('common.meta.description'),
      url: 'https://bravefrontierheroes.com/',
      imageUrl: 'https://bravefrontierheroes.com/ogp.png',
      ogType: 'website',
      twitterCardType: 'summary_large_image'
    });
    return head.get();
  }
};